import { IconShieldCheck } from '@tabler/icons-react';

import { registerBlockPlugin } from '../../core/BlockPluginRegistry';
import type { BlockPlugin } from '../../core/types';
import { RiskRegisterBlockView } from './RiskRegisterBlockView';

export const riskRegisterPlugin: BlockPlugin = {
    name: 'riskRegister',
    displayName: 'Risk Register',
    hasData: false,
    Component: RiskRegisterBlockView,
    toolbarInsert: {
        icon: <IconShieldCheck size={16} />,
        title: 'Risk Register',
        description: 'Add risk register from Notion',
        category: 'component'
    }
};

registerBlockPlugin(riskRegisterPlugin);
